<!-- 不合格销毁历史 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <subComponents @selectDataAction="selectDataAction" ref="showSelectData"></subComponents>
        <el-dialog :visible.sync="showStatus" :title="'填写销毁回执'" width="50%" :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="true" center>
            <submitReportModal v-if="showStatus" ref="submitReportModal" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></submitReportModal>
        </el-dialog>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table ref="table" size="mini" show-summary :summary-method="getSummaries" @selection-change="mainSelectionChange" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                      highlight-current-row>
                <el-table-column type="selection" width="50"></el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                            <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
								}}</a>
                            </span>
                            <div v-else-if="tableValye.entityField == 'dumAnnex'">
                                <ul v-if="scope.row.dumAnnex" class="upload_ul">
                                    <li v-for="(val,key) in scope.row.dumAnnex.split(',')" :key="key">
                                        <cusImage style="width: 20px; height: 20px;" :src="`${imgUrl}/${val}`" :preview-src-list="pictureShow(scope.row.dumAnnex.split(','))">
                                        </cusImage>
                                    </li>
                                </ul>
                            </div>
                            <el-tag v-else-if="tableValye.entityField == 'dumState'" size="mini" type="primary">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import submitReportModal from './submitReportModal.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        submitReportModal
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                bgmId: "",
                bgmName: "",
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,

            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            selectVal: [],
            parentSearchData: {
                smId: "",
            },
            DialogVisible: false,
            seId: "",
            seIndex: "",
            seType: "",
            seWidth: "",
            seTitle: "",
            imgUrl: '',
            sField: '',
            showStatus: false,
            actionData: {},
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (column.property == "psmoney" || column.property == "psprice") {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return this.toDecimal(prev + curr);
                            } else {
                                return this.toDecimal(prev)
                            }
                        }, 0);
                        if (column.property == "psmoney") {
                            sums[index] = this.$common.getDecimalInfo(3, sums[index])
                        } else {
                            sums[index] = this.$common.getDecimalInfo(2, sums[index])
                        }
                    } else {
                        sums[index] = '';
                    }
                }
            });
            this.$nextTick(() => {
                this.$refs.table.doLayout()
            })
            return sums;
        },
        toDecimal(x) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return;
            }
            f = Math.round(x * 100) / 100;
            return f;
        },
        mainSelectionChange(val) {
            this.selectVal = val;

        },
        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e) {
                this.getDataList()
            }
            // this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item);
            });
            return imgList;
        },
        selectDataAction(selectedData = {}, name, value) {
            switch (name) {
                case "bgmId":
                    this.getRequestData.bgmId = selectedData.bgmId;
                    this.getRequestData.bgmName = selectedData.bgmName;
                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList
                this.getButtonList();
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {

            if (actionData.actionType != 15 && actionData.actionType != 9 && actionData.actionType != 8) {
                if (this.selectVal.length != 1) {
                    this.$message({
                        message: "请选择一条数据操作·",
                        type: "error",
                    });
                    return false;
                }
                var dataInfo = this.selectVal[0];
            }
            switch (actionData.actionType) {
                case 0:
                    this.$refs["processAuditAction"].openBox(0, dataInfo.dumId);
                    break;
                case 1:
                    this.$refs["processAuditAction"].openBox(1, dataInfo.dumId);
                    break;
                case 6:
                    console.log('填写销毁回执');
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: dataInfo,
                    }
                    break
                case 8:
                    this.showPrintPlan()
                    break
                case 9:
                    this.exportData()
                    break
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        //  导出
        exportData() {
            this.getDataList()
            if (this.returnData.list.length == 0) {
                this.$message.warning("暂无数据")
                return
            }
            this.getRequestData.ormId = JSON.parse(
                sessionStorage.getItem("loginInfo")
            ).ormId;
            window.location.href = this.requesUrl + '/Desunqua/exportHis' + this.$common.getUrl(this.getRequestData)
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 打印方案
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                var list = this.selectVal.map((item) => item.dumId);
                // 选中的数据
                this.$refs.printPlan.openDia(list, sessionStorage.getItem('printSource').replace(/\"/g, ""), sessionStorage.getItem('printJurId'), "", "all")
            } else {
                return
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getUnqualifiedDestructionHistory(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur()
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.folvt {
    overflow: hidden;
}
.upload_ul {
    width: 280px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.upload_ul li {
    position: relative;
    width: 22px;
    height: 22px;
    margin-right: 3px;
    margin-bottom: 3px;
    border: 1px solid #dedede;
}
.upload_ul li ::v-deep .el-image__error {
    font-size: 5px;
}
.upload_ul li ::v-deep .cus-image {
    width: 20px !important;
    height: 20px !important;
}
.upload_ul li ::v-deep .cus-image img {
    width: 20px !important;
    height: 20px !important;
}
</style>